/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductVariantReserved {
  productVariantId?: number;
  reservationType?: ProductVariantReserved.ReservationTypeEnum;
  reserved?: number;
}
export namespace ProductVariantReserved {
  export type ReservationTypeEnum =
    | 'Fidelization'
    | 'Acquisition'
    | 'Marketing'
    | 'Incentive_Bflu';
  export const ReservationTypeEnum = {
    Fidelization: 'Fidelization' as ReservationTypeEnum,
    Acquisition: 'Acquisition' as ReservationTypeEnum,
    Marketing: 'Marketing' as ReservationTypeEnum,
    IncentiveBflu: 'Incentive_Bflu' as ReservationTypeEnum
  };
}
